import { post } from "../utilities/ajax";

// Import Plyr for video players
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';

export default class MediaPlayer {

    constructor() {
        this.plyrio();
        this.WatchListConfig();
    }

    plyrio() {
        // Initialize the main player
        const playerElement = document.querySelector('#streamit_player');
        if (playerElement) {
            // Get player configuration and sources from PHP-rendered data attributes
            const playerContainer = document.querySelector('.streamit-player-ctrl');
            if (!playerContainer) return;

            const playerConfig = jQuery(playerContainer).data('player_controls') || {};
            const sources = jQuery(playerContainer).data('sources') || [];
            const post_type = jQuery(playerContainer).data('post_type');
            const user_id = jQuery(playerContainer).data('user_id');
            const post_id = jQuery(playerContainer).data('post_id');
            const currentTime = jQuery(playerContainer).data('current_time');
            const i18n = playerConfig.i18n || {}; // Get localized text from PHP
            const self = this; // Store reference to class instance

            try {
                // Initialize Plyr player with configuration from PHP
                const player = new Plyr('#streamit_player', playerConfig);
                console.log(player);
                
                window.streamitPlayerInstance = player; // Store reference globally for external access

                // When player is ready, setup additional features
                playerElement.addEventListener('ready', function (e) {
                    const plyr = e.detail.plyr;

                    // Add sources menu if sources are provided and the sources control is enabled
                    if (sources && sources.length > 0 && playerConfig.controls?.includes('sources')) {
                        self.addSourcesMenu(plyr, sources, i18n);
                    }

                    // Initialize advertisement manager if ads are enabled
                    self.initializeAdvertisements(plyr, playerContainer);
                });

                // Set saved playback position if available
                if (currentTime > 5) {
                    player.currentTime = currentTime;
                }

                // Set up time tracking - only update server after 180 seconds of progress
                // This prevents excessive AJAX requests for short viewing sessions
                let lastUpdateTime = 0;
                player.on('timeupdate', (event) => {
                    const currentTime = event.detail.plyr.currentTime;
                    const totalTime = event.detail.plyr.duration;

                    if (currentTime > 180 && Math.abs(currentTime - lastUpdateTime) > 10) {
                        this.UpdateWatchedTime(currentTime, post_type, user_id, totalTime, post_id);
                        lastUpdateTime = currentTime;
                    }
                });

                // Also update time on play, pause, and seeking events
                player.on('play', () => this.updatePlayerProgress(player, post_type, user_id, post_id));
                player.on('pause', () => this.updatePlayerProgress(player, post_type, user_id, post_id));
                player.on('seeked', () => this.updatePlayerProgress(player, post_type, user_id, post_id));
            } catch (error) {
                console.error('Error initializing player:', error);
            }
        }
        // Handle trailer player if exists (with error handling)
        this.initializeTrailerPlayer();
    }

    /**
     * Initialize advertisements for the player
     * @param {Plyr} player The Plyr player instance
     * @param {HTMLElement} playerContainer The player container element
     */
    initializeAdvertisements(player, playerContainer) {
        // Check if advertisements are enabled
        const adsEnabled = jQuery(playerContainer).data('enabled');
        if (!adsEnabled) return;

        // Ensure the LS_AdvertisementManager class is available
        if (typeof window.LS_AdvertisementManager === 'undefined') {
            console.warn('Advertisement Manager not available');
            return;
        }

        // Get advertisement configuration from data attributes
        const adsType = jQuery(playerContainer).data('ads-type');
        const isLiveStream = jQuery(playerContainer).data('is-live') === 'true';
        const vastUrl = jQuery(playerContainer).data('vast-url');
        const prerollAttr = jQuery(playerContainer).attr('data-prerollenabled');

        const prerollEnabled = prerollAttr === 'true';

        const midrollAttr = jQuery(playerContainer).attr('data-midrollenabled');
        const midrollEnabled = midrollAttr === 'true';
        const adFrequency = jQuery(playerContainer).data('ad-frequency');
        const postAttr = jQuery(playerContainer).attr('data-postrollEnabled');
        const postrollEnabled = postAttr === 'true';

        const htmlAds = jQuery(playerContainer).data('html-ads') || {};

        // Configure advertisement options
        const adOptions = {
            isLiveStream: isLiveStream,
            prerollEnabled: prerollEnabled,
            midrollEnabled: midrollEnabled,
            postrollEnabled: postrollEnabled,
            adFrequency: adFrequency || 5, // Default to 5 if not set
            htmlAds: htmlAds,
            i18n: player.config.i18n || {}
        };

        // Add VAST URL if available

        if (adsType === 'vast' && vastUrl) {
            adOptions.vastAdUrls = {
                any: [vastUrl],
            };
        }

        // Initialize the advertisement manager using the global class
        try {
            const adManager = new window.LS_AdvertisementManager(player, adOptions);
            window.streamitAdManager = adManager; // Store reference globally
            console.log('Advertisement manager initialized successfully');
        } catch (error) {
            console.error('Failed to initialize advertisement manager:', error);
        }
    }

    /**
     * Updates the player progress
     * @private
     */
    updatePlayerProgress(player, post_type, user_id, post_id) {
        if (!player || player.destroyed) return;

        const currentTime = player.currentTime;
        const totalTime = player.duration;

        if (currentTime > 0) {
            this.UpdateWatchedTime(currentTime, post_type, user_id, totalTime, post_id);
        }
    }

    /**
     * Adds the sources menu to the player controls
     * @private
     */
    addSourcesMenu(plyr, sources, i18n) {
        // First, verify player is valid
        if (!plyr) {
            console.warn('Invalid player instance provided to addSourcesMenu');
            return;
        }

        // Wait for player to be ready and have controls
        const checkAndAddControls = () => {
            // Return early if player was destroyed
            if (plyr.destroyed) return;

            // If controls aren't available yet, wait and try again
            if (!plyr.elements || !plyr.elements.controls) {
                console.log('Controls not ready yet, waiting...');
                setTimeout(checkAndAddControls, 200);
                return;
            }

            // Now we can safely add our sources menu
            // Create sources menu container
            const sourcesMenu = document.createElement('div');
            sourcesMenu.className = 'plyr__sources';
            sourcesMenu.innerHTML = `
                <div class="plyr__sources__header">
                    <h5>${i18n?.sources || 'Sources'}</h5>
                </div>
                <ul class="plyr__sources__list"></ul>
            `;

            // Add sources to menu
            const sourcesList = sourcesMenu.querySelector('.plyr__sources__list');
            sources.forEach((source, index) => {
                if (!source.name || !source.content) return;

                const sourceItem = document.createElement('li');
                sourceItem.className = 'plyr__sources__item';
                sourceItem.innerHTML = `
                    <button type="button" class="plyr__sources__button" data-source-index="${index}">
                        ${source.name}
                        ${source.quality ? `<span class="source-quality">(${source.quality})</span>` : ''}
                        ${source.language ? `<span class="source-language">${source.language}</span>` : ''}
                    </button>
                `;
                sourcesList.appendChild(sourceItem);

                // Add click handler for source selection
                sourceItem.querySelector('button').addEventListener('click', () => {
                    // Update active state
                    sourcesList.querySelectorAll('.plyr__sources__button').forEach(btn =>
                        btn.classList.remove('active')
                    );
                    sourceItem.querySelector('button').classList.add('active');

                    // Switch source and close menu
                    this.switchSource(plyr, source);
                    sourcesMenu.classList.remove('plyr__sources--active');
                });
            });

            // Add sources button to controls
            const controls = plyr.elements.controls;
            const sourcesButton = document.createElement('button');
            sourcesButton.type = 'button';
            sourcesButton.className = 'plyr__control plyr__control--sources';
            sourcesButton.setAttribute('data-plyr', 'sources');
            sourcesButton.setAttribute('aria-label', i18n?.sources || 'Sources');

            // Use configurable icon from PHP or fallback to default icon
            const sourcesIcon = i18n?.sourcesIcon || `
               <svg id="Layer_1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="m3 8h10a1 1 0 0 0 2 0v-2a1 1 0 0 0 -2 0h-10a1 1 0 0 0 0 2z"/><path d="m17 8h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2z"/><path d="m21 16h-7a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/><path d="m11 15a1 1 0 0 0 -1 1h-7a1 1 0 0 0 0 2h7a1 1 0 0 0 2 0v-2a1 1 0 0 0 -1-1z"/><path d="m21 11h-11a1 1 0 0 0 0 2h11a1 1 0 0 0 0-2z"/><path d="m3 13h3a1 1 0 0 0 2 0v-2a1 1 0 0 0 -2 0h-3a1 1 0 0 0 0 2z"/></svg>
            `;
            sourcesButton.innerHTML = sourcesIcon;

            // Add click handler for sources button
            sourcesButton.addEventListener('click', (e) => {
                e.stopPropagation();
                sourcesMenu.classList.toggle('plyr__sources--active');
            });

            // Insert sources button and menu in player controls
            const settingsButton = controls.querySelector('[data-plyr="settings"]');
            if (settingsButton && settingsButton.parentNode) {
                settingsButton.parentNode.insertBefore(sourcesButton, settingsButton);
                settingsButton.parentNode.insertBefore(sourcesMenu, settingsButton);
            } else {
                controls.appendChild(sourcesButton);
                controls.appendChild(sourcesMenu);
            }

            // Close sources menu when clicking outside
            document.addEventListener('click', (e) => {
                if (!sourcesMenu.contains(e.target) && !sourcesButton.contains(e.target)) {
                    sourcesMenu.classList.remove('plyr__sources--active');
                }
            });
        };

        // Start the process
        checkAndAddControls();
    }

    /**
     * Initialize the trailer player if it exists
     * @private
     */
    initializeTrailerPlayer() {
        const trailerContainer = document.querySelector('.streamit-trailer-player-ctrl');
        if (!trailerContainer) return;

        const trailerControls = jQuery(trailerContainer).data('player_controls');
        if (!trailerControls) return;

        try {
            setTimeout(() => {
                const player = new Plyr('.streamit_trailer_player', trailerControls);
                player.muted = true;

                player.on('ready', () => {
                    player.play();
                    jQuery('.video-section').addClass('trailer-play');
                    this.setupTrailerMuteToggle(player);
                });

                player.on('error', (error) => {
                    console.error('Trailer player error:', error);
                });
            }, 2000);
        } catch (error) {
            console.error('Error initializing trailer player:', error);
        }
    }

    /**
     * Switches the player source to a new source
     * 
     * @param {Plyr} player - The current Plyr player instance
     * @param {Object} source - The source object containing content and metadata
     */
    switchSource(player, source) {
        if (!source || !source.content) {
            console.warn('Invalid source provided');
            return;
        }

        // Get required data from original container
        const playerContainer = document.querySelector('.streamit-player-ctrl');
        if (!playerContainer) return;

        const playerConfig = jQuery(playerContainer).data('player_controls') || {};
        const sources = jQuery(playerContainer).data('sources') || [];
        const post_type = jQuery(playerContainer).data('post_type');
        const user_id = jQuery(playerContainer).data('user_id');
        const post_id = jQuery(playerContainer).data('post_id');
        const i18n = playerConfig.i18n || {}; // Get localized text from PHP

        // Store the source name for later to highlight active button
        const currentSourceName = source.name;

        // Save current player state
        const currentTime = player.currentTime;
        const wasPlaying = !player.paused;

        try {
            // Destroy current player
            player.destroy();

            // Replace inner HTML with new source
            playerContainer.innerHTML = source.content;

            // Reinitialize player
            const newPlayer = new Plyr('#streamit_player', playerConfig);

            // Save globally if needed
            window.streamitPlayerInstance = newPlayer;

            // Apply saved player state when ready
            newPlayer.once('ready', () => {
                if (currentTime > 0) {
                    try {
                        newPlayer.currentTime = currentTime;
                    } catch (e) {
                        console.warn('Could not set current time:', e);
                    }
                }

                if (wasPlaying) {
                    try {
                        newPlayer.play();
                    } catch (e) {
                        console.warn('Could not autoplay after source switch:', e);
                    }
                }

                // Add sources menu after player is ready
                if (sources && sources.length > 0 && playerConfig.controls?.includes('sources')) {
                    // Small delay to ensure player DOM is fully initialized
                    setTimeout(() => {
                        this.addSourcesMenu(newPlayer, sources, i18n);

                        // After sources menu is added, highlight the active source
                        setTimeout(() => {
                            // Find all source buttons and remove active class
                            document.querySelectorAll('.plyr__sources__button').forEach(btn => {
                                btn.classList.remove('active');
                            });

                            // Find the button for the current source and add active class
                            const sourceButtons = document.querySelectorAll('.plyr__sources__button');
                            sourceButtons.forEach(btn => {
                                const buttonText = btn.textContent.trim();
                                if (buttonText.startsWith(currentSourceName)) {
                                    btn.classList.add('active');
                                }
                            });
                        }, 100);
                    }, 100);
                }
            });

            // Set up watch time tracking with throttling
            let lastUpdateTime = 0;
            const updateThreshold = 10; // Update server at most every 10 seconds

            newPlayer.on('timeupdate', () => {
                const currentTime = newPlayer.currentTime;
                const totalTime = newPlayer.duration;

                if (currentTime > 180 && Math.abs(currentTime - lastUpdateTime) > updateThreshold) {
                    this.UpdateWatchedTime(currentTime, post_type, user_id, totalTime, post_id);
                    lastUpdateTime = currentTime;
                }
            });

            // Also update on key events
            newPlayer.on('play', () => this.updatePlayerProgress(newPlayer, post_type, user_id, post_id));
            newPlayer.on('pause', () => this.updatePlayerProgress(newPlayer, post_type, user_id, post_id));
            newPlayer.on('seeked', () => this.updatePlayerProgress(newPlayer, post_type, user_id, post_id));

            return newPlayer;
        } catch (error) {
            console.error('Error while switching source:', error);
            return null;
        }
    }


    /**
     * Sets up the trailer mute toggle button functionality
     * @param {Plyr} player - The Plyr player instance
     */
    setupTrailerMuteToggle(player) {
        const muteButton = jQuery('#trailer-mute-toggle');

        if (muteButton.length) {
            muteButton.show();
            // Set initial state (trailer starts muted)
            player.muted = true;

            // Toggle mute/unmute on button click
            muteButton.on('click', function () {
                player.muted = !player.muted;

                // Update button icon and tooltip based on mute state
                if (player.muted) {
                    jQuery(this).html('<i class="icon-volume-slash"></i>');
                    jQuery(this).attr('data-bs-title', 'Unmute');
                } else {
                    jQuery(this).html('<i class="icon-volume-high"></i>');
                    jQuery(this).attr('data-bs-title', 'Mute');
                }
            });
        }
    }

    WatchListConfig() {
        const controls = jQuery('.streamit-player-ctrl').data('player_controls');
        const post_type = jQuery('.streamit-player-ctrl').data('post_type');
        const user_id = jQuery('.streamit-player-ctrl').data('user_id');
        const post_id = jQuery('.streamit-player-ctrl').data('post_id');
        const player = new Plyr('#streamit_player', controls);
        const currentTime = jQuery('.streamit-player-ctrl').data('current_time');
        if (currentTime > 5) {
            player.currentTime = currentTime
        }
        let lastUpdateTime = 0;
        player.on('timeupdate', (event) => {
            const currentTime = event.detail.plyr.currentTime
            const totalTime = event.detail.plyr.duration

            if (currentTime > 180) {
                this.UpdateWatchedTime(currentTime, post_type, user_id, totalTime, post_id);
                lastUpdateTime = currentTime;
            }
        });
        player.on('play', (event) => {
            const currentTime = player.currentTime
            const totalTime = player.duration
            this.UpdateWatchedTime(currentTime, post_type, user_id, totalTime, post_id);
            lastUpdateTime = currentTime;
        });
        player.on('pause', (event) => {
            const currentTime = player.currentTime
            const totalTime = player.duration
            this.UpdateWatchedTime(currentTime, post_type, user_id, totalTime, post_id);
            lastUpdateTime = currentTime;
        });
    }

    UpdateWatchedTime(currentTime, post_type, user_id, totalTime, post_id) {
        post('contine_watched_update', { watched_time: currentTime, post_type: post_type, user_id: user_id, watched_total_time: totalTime, post_id: post_id })
            .then((res) => {
                //success event
            })
            .catch((e) => {
                console.log(e);
            })
    }
}